<template>
  <section>
    <div v-if="searchResults">
      <div v-if="showOnlyProducts && searchResults.ItemId == -1" class="block" style="margin-top: -80px;">
        <div class="block__header">
          <h2 class="block__title">Select product</h2>
        </div>
        <div class="clearfix"></div>
      </div>
      <ul class="tabs" :class="{'products': showOnlyProducts && searchResults.ItemId == -1}">
        <li class="tabs__item" v-if="!showOnlyProducts" :class="{'tabs__item--active': searchResults.ItemId == -1}" @click="backToSearch">Found files</li>
        <li class="tabs__item" :class="{'tabs__item--active': item.ItemId == searchResults.ItemId}" v-for="item in searchProductList" @click="selectProduct(item)">{{item.Name}}</li>
      </ul>
      <div v-if="hasAccess">
        <search-intro v-if="!showOnlyProducts"></search-intro>
        <images-list v-if="searchResults.Images" :images="searchResults.Images" title="Images"></images-list>
        <documents-brochure v-if="searchResults.Brochure" :content="searchResults.Brochure"></documents-brochure>
        <documents-list v-for="documents in searchResults.Files" :content="documents.Items" :title="documents.Name"></documents-list>
      </div>
      <div v-if="!hasAccess">
        No access
      </div>
    </div>

  </section>
</template>

<script>
import RouteHeader from "../../shared/RouteHeader";
import SearchIntro from "./SearchIntro";

import ImagesList from "../images/ImagesList";
import DocumentsList from "../documents/DocumentsList";
import DocumentsBrochure from "../documents/DocumentsBrochure";

import { search, searchProducts, isProductAvailable } from "./SearchActions";

export default {
  data: function () {
    return {
      selectedProduct: -1,
      hasAccess: true,
      searchString: ""
    };
  },
  components: {
    RouteHeader, DocumentsList, DocumentsBrochure, SearchIntro, ImagesList
  },
  vuex: {
    getters: {
      searchResults: state => state.searchResults,
      searchProductList: state => state.searchProductList,
      header: state => state.header,
      hasAccess: state => state.hasAccess,
      showOnlyProducts: state => state.showOnlyProducts
    },
    actions: { search, searchProducts, isProductAvailable }
  },
  methods: {
    backToSearch () {
      this.selectedProduct = -1;
      this.$router.go("/search/" + this.$route.params.fileTypeId + "/" + this.searchString);
    },
    selectProduct (product) {
      this.selectedProduct = product.ItemId;
      window.fileTypeId = this.$route.params.fileTypeId;
      this.isProductAvailable(product.ItemId);
    },
    fetch () {
      window.fileTypeId = this.$route.params.fileTypeId;
      this.search(this.$route.params);
      if (this.$route.params.searchString) {
        this.searchProducts(this.$route.params.searchString);
      }
    }
  },
  route: {
    data ({ to: { params: { fileTypeId, searchString } } }) {
      if (searchString) {
        this.searchString = searchString;
      }
      this.fetch();
    }
  }
};
</script>
<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';
  @import '../../assets/scss/elements/button.scss';

  .clearfix::after {
    content: "";
    clear: both;
    display: table;
  }

  .tabs {
    list-style: none;
    margin: -70px 0 20px;
    padding: 0;

    &.products {
      margin: -30px 0 20px;
    }

    &__item {
      @extend .simple-button;
      margin: 0 10px 10px 0;

      &--active {
        color: $green;
        cursor: default;

        &:hover {
          background: $green_dark;
        }
      }
    }

    &--products {
      padding-right: 460px;
    }
  }
  
</style>



// WEBPACK FOOTER //
// Search.vue?2b41f6d0